import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useTitle = (defaultTitle) => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const titles = {
      '/': t('title.home'),
      '/register': t('title.register'),
      '/login': t('title.login'),
      '/download': t('title.download'),
      '/ranking': t('title.ranking'),
      '/terms-of-service': t('title.termsOfService'),
      '/privacy-policy': t('title.privacyPolicy'),
      '/refund-policy': t('title.refundPolicy'),
      '/forgot-password': t('title.forgotPassword'),
      '/wiki': t('title.wiki'),
      '/error': t('title.error'),
      '/support': t('title.support'),
      '/settings': t('title.settings'),
      '/shop': t('title.shop'),
      '/vote': t('title.vote'),
      '/purchase': t('title.purchase'),
      '/reward': t('title.reward'),
      '/dashboard': t('title.dashboard'),
      '/payment-success': t('title.paymentSuccess')
    };

    document.title = titles[location.pathname] || defaultTitle;
  }, [location, defaultTitle, t]);
};

export default useTitle;
